<template>
  <span>
    <button type="button" class="btn btn-danger" :class="btnClass" @click.stop="showModal = true">Delete</button>
    <ez-modal v-if="showModal" @close="showModal = false" size="m-small">
      <h3>
        <i class="fa fa-exclamation-triangle danger" aria-hidden="true"></i> Delete
      </h3>
      <p>
        <slot></slot>
      </p>
      <p>
        Once you delete something, there is no going back. Please be certain.
      </p>
      <div class="text-center">
        <button type="button" class="btn btn-danger" @click.stop="deleteItem()">Delete</button>
        <button class="btn btn-secondary" @click.stop="showModal = false">Cancel</button>
      </div>
    </ez-modal>
  </span>
</template>

<script>
import modal from "@/mixins/vue-ez-modal";

export default {
  name: "vue-ez-modal-delete",
  mixins: [modal],
  props: ["btnClass"],
  methods: {
    deleteItem() {
      this.$emit("deleteData");
      this.showModal = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/_global";

.danger {
  color: $danger;
}
h3 {
  margin-bottom: 1rem;
}
a,
a:not([href]):not([tabindex]) {
  color: $gray-400;

  &:hover,
  &:focus {
    color: darken($danger, 15%) !important;
  }
}
</style>
